module.exports = __webpack_public_path__ + "img/mask.5b7566dd.webp";